import React from "react";

interface FormFieldProps {
  label: string;
  htmlFor?: string;
  optional?: boolean;
  error?: string;
  span2?: boolean;
  children: React.ReactNode;
}

const FormField: React.FC<FormFieldProps> = ({ label, htmlFor, optional, error, span2, children }) => (
  <div className={`ds-form-field ${error ? "invalid" : ""} ${span2 ? "span-2" : ""}`}>
    <label htmlFor={htmlFor}>
      {label} {optional && <span className="opt">(opcional)</span>}
    </label>
    {children}
    {error && <span className="ds-form-error">{error}</span>}
  </div>
);

export default FormField;
